import React from 'react';

import Icon from '../../../../Icon/Icon';
import LogoRectangle from '../../../../Logos/LogoRectangle';

import * as styles from './ModalFlyout.module.scss';

interface props {
    onClose: ()=> void,
    isOpen: boolean,
    children: React.ReactNode
}

const ModalFlyout = ({ onClose, isOpen, children }: props): JSX.Element => {
    let animationClassName = isOpen ? styles.ModalFlyoutAnimateOpen : '';
    animationClassName = animationClassName || styles.ModalFlyoutAnimateClose;

    return (
        <aside className={`${styles.ModalFlyout} ${animationClassName}`}>
            <div className="flex justify-between">
                <LogoRectangle />
                <button type="button" onClick={onClose} className={styles.ModalFlyoutCloseButton}>
                    <Icon size={18}>
                        <Icon.Cross />
                    </Icon>
                </button>
            </div>
            {children}
        </aside>
    );
};

export default ModalFlyout;
